import React from 'react';
import { Edit, Trash2, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';
interface ContactsTableProps {
  onContactClick?: (id: number) => void;
}
const contacts = [{
  id: 1,
  name: 'Thomas Weber',
  company: 'TechCorp GmbH',
  email: 'thomas.weber@techcorp.de',
  phone: '+49 30 12345678',
  status: 'Kunde',
  tags: ['Kunde', 'Überfällig'],
  connectedOn: '05.01.2025',
  linkedin: '05.01.2025',
  followUp: '25.01.2025',
  notes: 'Aktiver Kunde seit 2024. Sehr zufrieden mit dem Service.'
}, {
  id: 2,
  name: 'Max Mustermann',
  company: 'Innovation AG',
  email: 'm.mustermann@innovation.de',
  phone: '+49 89 87654321',
  status: 'Interessiert',
  tags: ['Opener', 'Interessiert', 'Überfällig'],
  connectedOn: '10.01.2025',
  linkedin: '10.01.2025',
  followUp: '01.02.2025',
  notes: 'Interessiert an unseren Enterprise-Lösungen. Möchte Demo-Call vereinbaren.'
}, {
  id: 3,
  name: 'Michael Becker',
  company: 'StartUp Berlin',
  email: 'm.becker@startup.de',
  phone: '+49 30 99887766',
  status: 'Follow-up',
  tags: ['Opener', 'Interessiert', 'Follow-up', 'Überfällig'],
  connectedOn: '14.01.2025',
  linkedin: '14.01.2025',
  followUp: '20.01.2025',
  notes: 'CEO eines Startups. Sehr interessiert an Partnerschaft. Meeting nächste Woche geplant.'
}, {
  id: 4,
  name: 'Anna Schmidt',
  company: 'Digital Solutions',
  email: 'anna.schmidt@digital.de',
  phone: '+49 40 11223344',
  status: 'Erstnachricht',
  tags: ['Erstnachricht', 'Follow-up'],
  connectedOn: '12.01.2025',
  linkedin: '12.01.2025',
  followUp: '-',
  notes: 'Wartet auf Budget-Freigabe. Follow-up in 2 Wochen.'
}, {
  id: 5,
  name: 'Julia Fischer',
  company: 'Consulting Pro',
  email: 'julia.f@consulting.de',
  phone: '+49 69 55443322',
  status: 'Disqualifiziert',
  tags: ['Disqualifiziert'],
  connectedOn: '08.01.2025',
  linkedin: '08.01.2025',
  followUp: '-',
  notes: 'Kein Budget verfügbar. Möchte in 6 Monaten erneut kontaktiert werden.'
}];
const statusColors: Record<string, string> = {
  Opener: 'status-opener',
  Erstnachricht: 'status-erstnachricht',
  Interessiert: 'status-interessiert',
  Kunde: 'status-kunde',
  'Follow-up': 'status-follow-up',
  Überfällig: 'status-uberfällig',
  Disqualifiziert: 'status-disqualifiziert'
};
export function ContactsTable({
  onContactClick
}: ContactsTableProps) {
  const handleEdit = (id: number, e: React.MouseEvent) => {
    e.stopPropagation();
    console.log('Edit contact:', id);
  };
  const handleDelete = (id: number, e: React.MouseEvent) => {
    e.stopPropagation();
    console.log('Delete contact:', id);
  };
  const handleLinkedInClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    console.log('Open LinkedIn profile');
  };
  return <div className="rounded-xl bg-card border border-border overflow-hidden" data-id="element-36">
      <div className="p-6 border-b border-border flex items-center justify-between bg-[#fef5ee] dark:bg-white/5" data-id="element-37">
        <div data-id="element-38">
          <h2 className="text-lg font-semibold text-black dark:text-white" data-id="element-39">
            Kontakte
          </h2>
          <p className="text-sm text-muted-foreground mt-1" data-id="element-40">
            Verwalten Sie Ihre Kundenkontakte
          </p>
        </div>
        <div className="flex items-center gap-2" data-id="element-41">
          <Button variant="outline" size="sm" onClick={() => console.log('CSV Import')} data-id="element-42">
            CSV Import
          </Button>
          <Button variant="secondary" size="sm" onClick={() => console.log('Neuer Kontakt')} data-id="element-43">
            + Neuer Kontakt
          </Button>
        </div>
      </div>

      <div className="overflow-x-auto" data-id="element-44">
        <table className="w-full" data-id="element-45">
          <thead className="bg-[#fef5ee] dark:bg-white/5" data-id="element-46">
            <tr data-id="element-47">
              <th className="text-left text-xs font-medium text-muted-foreground px-6 py-3" data-id="element-48">
                Name
              </th>
              <th className="text-left text-xs font-medium text-muted-foreground px-6 py-3" data-id="element-49">
                Connected On
              </th>
              <th className="text-left text-xs font-medium text-muted-foreground px-6 py-3" data-id="element-50">
                LinkedIn
              </th>
              <th className="text-left text-xs font-medium text-muted-foreground px-6 py-3" data-id="element-51">
                Nachricht gesendet
              </th>
              <th className="text-left text-xs font-medium text-muted-foreground px-6 py-3" data-id="element-52">
                Follow-up
              </th>
              <th className="text-left text-xs font-medium text-muted-foreground px-6 py-3" data-id="element-53">
                Tags
              </th>
              <th className="text-left text-xs font-medium text-muted-foreground px-6 py-3" data-id="element-54">
                Notizen
              </th>
              <th className="text-left text-xs font-medium text-muted-foreground px-6 py-3" data-id="element-55">
                Aktionen
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border" data-id="element-56">
            {contacts.map(contact => <tr key={contact.id} onClick={() => onContactClick?.(contact.id)} className="hover:bg-[#fef5ee]/50 dark:hover:bg-white/5 transition-colors cursor-pointer" data-id="element-57">
                <td className="px-6 py-4" data-id="element-58">
                  <div className="flex items-center gap-3" data-id="element-59">
                    <div className="h-8 w-8 rounded-full bg-[#eb6641]/10 dark:bg-[#eb6641]/20 flex items-center justify-center text-[#eb6641] dark:text-[#ff8a65] font-medium text-sm" data-id="element-60">
                      {contact.name.charAt(0)}
                    </div>
                    <div data-id="element-61">
                      <div className="font-medium text-foreground" data-id="element-62">
                        {contact.name}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 text-sm text-foreground" data-id="element-63">
                  {contact.connectedOn}
                </td>
                <td className="px-6 py-4" data-id="element-64">
                  <div onClick={handleLinkedInClick} className="text-sm text-[#eb6641] flex items-center gap-1 hover:underline cursor-pointer" data-id="element-65">
                    <ExternalLink className="h-3 w-3" data-id="element-66" />
                    Profil
                  </div>
                </td>
                <td className="px-6 py-4 text-sm text-foreground" data-id="element-67">
                  {contact.linkedin}
                </td>
                <td className="px-6 py-4 text-sm text-foreground" data-id="element-68">
                  {contact.followUp}
                </td>
                <td className="px-6 py-4" data-id="element-69">
                  <div className="flex flex-wrap gap-1" data-id="element-70">
                    {contact.tags.map(tag => <span key={tag} className={`status-badge ${statusColors[tag] || ''}`} data-id="element-71">
                        {tag}
                      </span>)}
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-72">
                  <p className="text-sm text-muted-foreground max-w-xs truncate" data-id="element-73">
                    {contact.notes}
                  </p>
                </td>
                <td className="px-6 py-4" data-id="element-74">
                  <div className="flex items-center gap-1" data-id="element-75">
                    <Button variant="ghost" size="icon" className="h-8 w-8" onClick={e => handleEdit(contact.id, e)} data-id="element-76">
                      <Edit className="h-4 w-4" data-id="element-77" />
                    </Button>
                    <Button variant="ghost" size="icon" className="h-8 w-8 text-destructive hover:text-destructive" onClick={e => handleDelete(contact.id, e)} data-id="element-78">
                      <Trash2 className="h-4 w-4" data-id="element-79" />
                    </Button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}